import { fromJS, List } from 'immutable';
import { combineActions, createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';

export const initialState = fromJS({
  printUsers: List(),
  tempPrintUserId: null,
  isLoading: false,
});

// const
export const GET_PRINT_USERS = 'printUsers/GET_PRINT_USERS';
export const CREATE_PRINT_USER = 'printUsers/CREATE_PRINT_USER';
export const UPDATE_PRINT_USER = 'printUsers/UPDATE_PRINT_USER';
export const DELETE_PRINT_USER = 'printUsers/DELETE_PRINT_USER';
export const UPDATE_PRINT_USER_PASSWORD =
  'printUsers/UPDATE_PRINT_USER_PASSWORD';

// action creators
export const getPrintUsers = createAction(
  GET_PRINT_USERS,
  api.externalPrintUsers.getPrintUsers,
);
export const createPrintUser = createAction(
  CREATE_PRINT_USER,
  api.externalPrintUsers.createPrintUser,
);
export const updatePrintUser = createAction(UPDATE_PRINT_USER, (id, data) =>
  api.externalPrintUsers.updatePrintUser(id, data),
);
export const deletePrintUser = createAction(DELETE_PRINT_USER, (data) => ({
  promise: api.externalPrintUsers.deletePrintUser(data.id),
  data,
}));
export const updatePrintUserPassword = createAction(
  UPDATE_PRINT_USER_PASSWORD,
  (id, data) => api.externalPrintUsers.updatePrintUserPassword(id, data),
);

// reducer
const printUsers = handleActions(
  {
    [combineActions(
      `${CREATE_PRINT_USER}_REQUEST`,
      `${GET_PRINT_USERS}_REQUEST`,
      `${UPDATE_PRINT_USER}_REQUEST`,
      `${UPDATE_PRINT_USER_PASSWORD}_REQUEST`,
    )]: (state) => state.set('isLoading', true),

    [combineActions(
      `${CREATE_PRINT_USER}_ERROR`,
      `${GET_PRINT_USERS}_ERROR`,
      `${UPDATE_PRINT_USER}_ERROR`,
      `${DELETE_PRINT_USER}_ERROR`,
      `${UPDATE_PRINT_USER_PASSWORD}_ERROR`,
    )]: (state) => state.set('isLoading', false),

    [`${DELETE_PRINT_USER}_REQUEST`]: (state, { payload }) =>
      state.set('tempPrintUserId', payload.id).set('isLoading', true),

    [`${GET_PRINT_USERS}_SUCCESS`]: (state, { payload }) => {
      return state
        .set('printUsers', payload.getIn(['data', 'data'], List()))
        .set('isLoading', false);
    },

    [`${CREATE_PRINT_USER}_SUCCESS`]: (state, { payload }) =>
      state
        .update('printUsers', (users) =>
          users.push(payload.getIn(['data', 'data'])),
        )
        .set('isLoading', false),

    [`${UPDATE_PRINT_USER}_SUCCESS`]: (state, { payload }) => {
      const userId = payload.getIn(['data', 'data', 'id']);
      const index = state
        .get('printUsers')
        .findIndex((user) => user.get('id') === userId);

      return state
        .setIn(['printUsers', index], payload.getIn(['data', 'data']))
        .set('isLoading', false);
    },

    [`${DELETE_PRINT_USER}_SUCCESS`]: (state) =>
      state
        .update('printUsers', (users) =>
          users.filter(
            (user) => user.get('id') !== state.get('tempPrintUserId'),
          ),
        )
        .set('tempPrintUserId', null)
        .set('isLoading', false),

    [`${UPDATE_PRINT_USER_PASSWORD}_SUCCESS`]: (state) =>
      state.set('isLoading', false),
  },
  initialState,
);

export default printUsers;
